import React, { useRef } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import * as route from '../components/helpers/routes';
import { Flex } from 'reflexbox';
import Logo from '../images/capital-clues-logo.png';
import Reward from 'react-rewards';
import SettingsMenu from '../components/gameSetupAndLobby/SettingsMenu';
import { courseFriendlyName } from "../components/courseContent/courseObjects";
import { useColorMode } from '../components/helpers/ColorModeContext';

const HomePage = () => {
    const navigate = useNavigate();
    const rewardRef = useRef(null);
    const { mode } = useColorMode();

    const teamDetails = useSelector((state) => state.team?.teamDetails);
    const courseName = teamDetails?.currentCourseSelection;
    const courseProgress = courseName && teamDetails?.courseProgress?.[courseName];
    const hasInProgressCourse = !!(courseProgress && !courseProgress.toString().includes(route.END));
    const friendlyName = courseFriendlyName(courseName) || 'course';

    const handlePlayGame = () => navigate(route.PROFILE_SETUP);
    const handleViewCourses = () => navigate(route.COURSEVIEWER_MAIN);
    const handleWhatToExpect = () => navigate(route.WHAT_TO_EXPECT);

    const handleLogoClick = () => {
        rewardRef.current?.rewardMe();
    };

    return (
        <Flex flexDirection="column" justifyContent="space-between" style={{ height: '100%' }}>
            <Flex style={{ width: '100%', padding: '16px 0', justifyContent: 'flex-end' }}>
                <SettingsMenu />
            </Flex>
            <Flex style={{ height: '100%' }} justifyContent="center" alignItems="center">
                <Reward
                    ref={rewardRef}
                    type="memphis"
                    config={{
                        containerStyle: { pointerEvents: 'none' },
                    }}
                >
                    <img
                        src={Logo}
                        style={{
                            width: '280px',
                            cursor: 'pointer',
                            filter: mode === 'dark' ? 'invert(1)' : 'none',
                        }}
                        alt="logo"
                        onClick={handleLogoClick}
                    />
                </Reward>
            </Flex>

            <Flex flexDirection="column" style={{ paddingBottom: '4px' }}>
                {hasInProgressCourse && (
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => navigate(courseProgress)}
                        style={{ margin: '8px 0' }}
                    >
                        {`Resume ${friendlyName}`}
                    </Button>
                )}
                <Button variant="contained" color="primary" fullWidth onClick={handlePlayGame} style={{ margin: '8px 0' }}>
                    Play a Game
                </Button>
                <Button variant="outlined" color="primary" fullWidth onClick={handleViewCourses} style={{ margin: '8px 0' }}>
                    View Courses
                </Button>
                <Button variant="outlined" color="primary" fullWidth onClick={handleWhatToExpect} style={{ margin: '8px 0' }}>
                    What to Expect
                </Button>
            </Flex>
        </Flex>
    );
};

export default HomePage;
